import React from "react";
import ButtonCommonComponent from "./ButtonCommonComponent";
import DisplaySelectedOptionsList from "./DisplaySelectedOptionsList";

const optionsSkill = [
  { value: "Skill Name 1", label: "Skill Name 1" },
  { value: "Skill Name 2", label: "Skill Name 2" },
  { value: "Skill Name 3", label: "Skill Name 3" },
  { value: "Skill Name 11", label: "Skill Name 11" },
  { value: "Skill Name 22", label: "Skill Name 22" },
  { value: "Skill Name 33", label: "Skill Name 33" },
];

export default function ProfileDetails({
  isSkillListPresent,
  displayCompanyNameAndPassword,
}) {
  return (
    <>
      <div className="client-profile-details-tab-main-div">
        <div className="custom-d-flex flex-nowrap">
          <div className="col-12 col-md-8 client-profile-details-left-div">
            <div className="d-flex flex-nowrap align-items-start">
              <div className="client-profile-details-img-div flex-shrink-0"></div>
              <div>
                <h3 className="font-36-nunito-semibold pt-20 ">Client Name</h3>
                <a
                  href="https://myrl.tech/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="font-18-nunito-light client-profile-website-link pt-20">
                    WebsiteLink
                  </span>
                </a>
                <h5 className="font-16-NunitoSans-600 color-white-66 pt-20">
                  <img
                    src={"/img/desktop/icons/gray-team-icon.svg"}
                    alt=""
                    className="client-profile-team-icon"
                  />{" "}
                  Team Size : 100+
                </h5>
              </div>
            </div>
            <h4 className="font-14-NunitoSans-600 mt-50">About Company</h4>
            <p className="font-18-nunito-light color-white-66 pt-20">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur.
            </p>
            {isSkillListPresent && (
              <>
                <h4 className="font-14-NunitoSans-600 mt-50">Specialises in</h4>
                <DisplaySelectedOptionsList
                  displayListSelected={optionsSkill}
                  isDisplayRemoveIcon={false}
                />
              </>
            )}
          </div>
          <div className="col-12 col-md-4 client-profile-details-right-div">
            {displayCompanyNameAndPassword && (
              <div>
                <h3 className="font-14-NunitoSans-600 mb-23">
                  Company Username
                </h3>
                <p className="font-16-NunitoSans-600 color-white-66 mb-23">
                  MyrleC
                </p>
                <h3 className="font-14-NunitoSans-600 mb-23">
                  Company Password
                </h3>
                <p className="font-16-NunitoSans-600 color-white-66 mb-38">
                  Last updated 3 days ago
                </p>
                <ButtonCommonComponent
                  extraClassName="login-btn--modal-btn-border login-btn--px-45 mr-30 mb-70"
                  text="Generate Again"
                  onClick={() => console.log("Generate Again")}
                />
              </div>
            )}
            <h3 className="font-14-NunitoSans-600">Point of Contact</h3>
            <p className="font-16-NunitoSans-600 color-white-66 custom-d-flex flex-nowrap pt-35 align-items-center">
              <img
                src={"/img/desktop/icons/gray-profile-icon.svg"}
                alt=""
                className="client-profile-details-profile-icon"
              />
              Rajesh Chopra
            </p>
            <p className="font-16-NunitoSans-600 color-white-66 custom-d-flex flex-nowrap pt-35 align-items-center">
              <img
                src={"/img/desktop/icons/gray-message-icon.svg"}
                alt=""
                className="client-profile-details-message-icon"
              />
              Rajes@mail.com
            </p>
            <p className="font-16-NunitoSans-600 color-white-66 custom-d-flex flex-nowrap pt-35 align-items-center">
              <img
                src={"/img/desktop/icons/gray-phone-icon.svg"}
                alt=""
                className="client-profile-details-call-icon"
              />
              +91-1431231345
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

ProfileDetails.defaultProps = {
  isSkillListPresent: false,
  displayCompanyNameAndPassword: false,
};
